import scssVariables from 'styles/sass-variables.module.scss';

export const modalOverrides = {
  root: () => ({
    '& > .MuiBox-root': {
      position: 'absolute',
      minHeight: 200,
      top: '50%',
      left: '50%',
      outline: 'none',
      borderRadius: '8px',
      transform: 'translate(-50%, -50%)',
      backgroundColor: scssVariables.white,
    },
  }),
};
